import ServicePageLayout from '@/components/ServicePageLayout';

const COMMERCIAL_DATA = {
  id: 'commercial',
  title: 'Commercial Services',
  subtitle: 'Elevate your brand with visuals that sell, inspire, and leave a lasting impression.',
  category: 'Commercial',
  heroImage: '/images/Commercial/Hero_Image.jpeg',
  sections: [
    {
      id: 'brand-advertising',
      title: 'Brand & Advertising',
      items: [
        {
          title: 'Brand Identity Photography',
          description: 'Cohesive visual content that defines your brand personality across all touchpoints.',
          image: '/images/Commercial/Brand_Identity.jpg',
        },
        {
          title: 'Advertising Campaigns',
          description: 'High-impact campaign imagery for print, digital, outdoor, and social media advertising.',
          image: '/images/Commercial/Advertising_Campaigns.jpg',
        },
        {
          title: 'Lifestyle & Brand Storytelling',
          description: 'Authentic lifestyle imagery that connects your brand with its audience on an emotional level.',
          image: '/images/Commercial/Lifestyle_&_Brand.jpg',
        },
      ],
    },
    {
      id: 'product-ecommerce',
      title: 'Product & E-Commerce',
      items: [
        {
          title: 'Product Photography',
          description: 'Clean, detailed product shots on white or creative backgrounds for catalogs and retail.',
          image: '/images/Commercial/Product_Photography.jpg',
        },
        {
          title: 'E-Commerce Photography',
          description: 'High-volume, consistent product imagery optimized for Amazon, Shopify, and online marketplaces.',
          image: '/images/Commercial/E-Commerce_Photography.jpg',
        },
        {
          title: '360° Product Photography',
          description: 'Interactive 360-degree product views for enhanced online shopping experiences.',
          image: '/images/Commercial/360_Product_Photography.jpg',
        },
      ],
    },
    {
      id: 'corporate-business',
      title: 'Corporate & Business',
      items: [
        {
          title: 'Corporate Headshots & Portraits',
          description: 'Professional headshots for executives, team members, and company directories.',
          image: '/images/Commercial/Corporate_Headshots.jpg',
        },
        {
          title: 'Office & Workspace Photography',
          description: 'Showcase your workplace culture with polished interior and team environment photography.',
          image: '/images/Commercial/Office_&_Workspace.jpg',
        },
        {
          title: 'Annual Report & PR Photography',
          description: 'Visual content for annual reports, press releases, and corporate communications.',
          image: '/images/Commercial/Annual_Report.jpg',
        },
      ],
    },
    {
      id: 'food-hospitality',
      title: 'Food & Hospitality',
      items: [
        {
          title: 'Food Photography',
          description: 'Mouth-watering food photography that makes your menu items irresistible.',
          image: '/images/Commercial/Food.jpeg',
        },
        {
          title: 'Restaurant & Cafe Photography',
          description: 'Ambient interior photography showcasing your dining space, ambiance, and brand experience.',
          image: '/images/Commercial/Restaurant_&_Cafe.jpg',
        },
        {
          title: 'Hotel & Resort Photography',
          description: 'Luxury property photography for hotels, resorts, and hospitality brands across diverse locations.',
          image: '/images/Commercial/Hotel_&_Resort.jpg',
        },
      ],
    },
    {
      id: 'commercial-films',
      title: 'Digital Content & Films',
      items: [
        {
          title: 'Professional Commercial Video Production',
          description: 'Broadcast-quality commercial videos for TV, digital platforms, and social media campaigns.',
          image: '/images/Commercial/Commercial_Video_Production.jpg',
        },
        {
          title: 'Product Demo & Unboxing Videos',
          description: 'Engaging product demonstration and unboxing videos that showcase features and benefits.',
          image: '/images/Commercial/Unboxing_Videos.jpg',
        },
        {
          title: 'Brand Story Film Production Services',
          description: 'A cinematic brand story film that communicates your mission, values, and unique proposition.',
          image: '/images/Commercial/Brand_Story_Film.jpg',
        },
      ],
    },
    {
      id: 'commercial-addons',
      title: 'Add-Ons',
      items: [
        {
          title: 'Prop & Set Design',
          description: 'Custom props, backdrops, and set design for creative and thematic product shoots.',
          image: '/images/Commercial/Prop_&_Set_Design.jpg',
        },
        {
          title: 'Model Casting & Coordination',
          description: 'Professional model selection and coordination for lifestyle and campaign shoots.',
          image: '/images/Commercial/Model_Casting.jpg',
        },
        {
          title: 'Rush Delivery',
          description: 'Expedited editing and delivery for time-sensitive campaigns and product launches.',
          image: '/images/Commercial/Rush_Delivery.jpg',
        },
      ],
    },
    {
      id: 'commercial-deliverables',
      title: 'Deliverables',
      items: [
        {
          title: 'Multi-Format Image Delivery',
          description: 'Images optimized for print (CMYK/TIFF), web (sRGB/JPEG), and social media platforms.',
          image: '/images/Commercial/Multi-Format_Image.jpg',
        },
        {
          title: 'Video Deliverables Package',
          description: 'Final cut + social media cuts + raw footage delivered via secure cloud platform.',
          image: '/images/Commercial/Video_Deliverables.jpg',
        },
        {
          title: 'Usage License & Rights',
          description: 'Clear licensing terms for commercial use, including print, digital, and broadcast rights.',
          image: '/images/Commercial/License_&_Rights.jpg',
        },
      ],
    },
  ],
};

export default function CommercialPage() {
  return <ServicePageLayout data={COMMERCIAL_DATA} />;
}
